// @flow
import { connect } from "react-redux";
import JournalsPageView from "./view";
import { showBlog } from "../state/blogs/actions";

export default connect(
    state => ({
        blogs: state.blogs.all
    }),
    dispatch => ({
        onShowBlog: blog => dispatch(showBlog(blog))
    })
)(JournalsPageView);



// WEBPACK FOOTER //
// ./src/journals-page-view/index.js